import { setHeaderHeightVariable } from './modules/set-header-height-variable.js';
import { setViewportWidthVariable } from './modules/set-viewport-width-variable.js';
import { delayedScroll } from './modules/delayed-scroll.js';
import { disableTelOnPC } from './modules/disable-tel-on-pc.js';
import { modal } from './modules/modal.js';
import { tabs } from './modules/tabs.js';
import { accordion } from './modules/accordion.js';
import { contactFormConfirm } from './modules/contact-form-confirm.js';
import { contactForm } from './modules/contact-form.js';
import { postalCodeLookup } from './modules/postal-code-lookup.js';
import { birthYears } from './modules/birth-years.js';
import { scrollAnimation } from './modules/scroll-animation.js';
import { fileDrop } from './modules/file-drop.js';
import { topServicesSlider } from './modules/top-services-slider.js';
import { topNewsSlider } from './modules/top-news-slider.js';
import { topColumnSlider } from './modules/top-column-slider.js';
import { loopSlider } from './modules/loop-slider.js';

/**
 * メインJavaScript - 各モジュールの初期化
 */
document.addEventListener('DOMContentLoaded', () => {
  setHeaderHeightVariable();
  setViewportWidthVariable();
  delayedScroll();
  disableTelOnPC();
  modal();
  tabs();
  accordion();
  contactFormConfirm();
  contactForm();
  postalCodeLookup();
  birthYears();
  scrollAnimation();
  fileDrop();
  topServicesSlider();
  topNewsSlider();
  topColumnSlider();
  loopSlider();
});
